// AssetGroup — optional layer between Organization and Asset.
// Cartera, Edificio, Flota, Proyecto, Zona, Sucursal, Etapa, etc. The engine
// doesn't care what label the recipe puts on it; it just provides a place
// to bucket assets so admins can scope inspector access.
import { isoDateTimeSchema } from "@bitacorapro/shared";
import { z } from "zod";
import { assetGroupIdSchema, organizationIdSchema } from "../ids.js";
export const assetGroupSchema = z.object({
    id: assetGroupIdSchema,
    organizationId: organizationIdSchema,
    name: z.string().trim().min(1).max(255),
    description: z.string().trim().max(2000).optional(),
    createdAt: isoDateTimeSchema,
});
export const assetGroupCreateSchema = assetGroupSchema
    .omit({ id: true, createdAt: true })
    .extend({ id: assetGroupIdSchema.optional() });
export const assetGroupUpdateSchema = assetGroupSchema
    .pick({ name: true, description: true })
    .partial();
//# sourceMappingURL=asset-group.js.map